<template>
  <div ref="refSelect" class="asset-select" :class="{ opened: showAssetsList }">
    <div class="field-wrapper">
      <DeployerUiFormInputText
        v-model="asset"
        :label="texts.fields[2].label"
        :placeholder="placeholder"
        :tooltip="texts.fields[2].tooltip"
        :svg-icon="AssetsSvg"
        :top-error="topError"
        @click.prevent="showAssetsList = true"
      />
      <div
        class="chevron"
        @click.prevent="showAssetsList = !showAssetsList"
        v-html="ChevronSvg"
      />
    </div>
    <div v-if="showAssetsList" class="options-wrapper">
      <ul class="options">
        <li v-for="item in filteredAssetList" :key="item.assetName">
          <DeployerUiFormAssetOption
            :label="item.symbol"
            :is-selected="
              selectedAssets.some(
                (asset) =>
                  asset.symbol === item.symbol &&
                  asset.blockchain === item.blockchain &&
                  asset.address === item.address &&
                  asset.address === item.address
              )
            "
            @click="selectAsset(item)"
          />
        </li>
      </ul>
      <div class="request">
        {{ texts.request_additional }}
      </div>
    </div>
  </div>
</template>

<script setup>
import AssetsSvg from '~/layers/base/assets/icons/assets.svg?raw'
import ChevronSvg from '~/layers/base/assets/icons/chevron-up.svg?raw'
const selectedAssets = defineModel()
const assetsList = ref([])
const asset = ref('')
const showAssetsList = ref(false)
const refSelect = ref(null)

const textsStore = useTextsStore()
const whitelabelStore = useWhitelabelStore()
const accountStore = useAccountStore()
const texts = computed(() => {
  return textsStore.deploy.settings
})

onClickOutside(refSelect, () => {
  showAssetsList.value = false
  asset.value = ''
})

const emit = defineEmits(['show-asset-list-changed'])

const feedsAvailable = computed(() => {
  return (
    accountStore.getAccountNumberOfFeeds.maximum -
    accountStore.getAccountNumberOfFeeds.deployed -
    selectedAssets.value.length
  )
})

const topError = computed(() => {
  if (feedsAvailable.value <= 0 && showAssetsList.value) {
    return 'Limit of feeds reached. Upgrade plan or remove feeds to add more.'
  }
})

let symbolsData, symbolsDataError

if (whitelabelStore?.config?.asset_list_api) {
  const response = await useFetch(whitelabelStore.config.asset_list_api)
  symbolsData = response.data
  symbolsDataError = response.error
} else {
  console.error('asset_list_api is undefined')
}

if (symbolsDataError.value) {
  console.error('Error fetching symbols', symbolsDataError)
}

if (symbolsData)
  assetsList.value = symbolsData.value.map((item) => ({
    symbol: item.Symbol,
    name: item.CustomName,
    blockchain: item.AssetName.split('-')[0],
    address: item.AssetName.split('-')[1],
    assetName: item.AssetName,
    exchanges: item.Exchanges
  }))

const filteredAssetList = computed(() => {
  if (!asset.value) return assetsList.value

  return assetsList.value.filter((item) =>
    item.symbol.toLowerCase().includes(asset.value.toLowerCase())
  )
})

const selectAsset = (item) => {
  console.log('item', item)
  const index = selectedAssets.value.findIndex(
    (asset) =>
      asset.symbol === item.symbol &&
      asset.blockchain === item.blockchain &&
      asset.address === item.address &&
      asset.exchanges === item.exchanges
  )

  if (index === -1) {
    if (feedsAvailable.value) selectedAssets.value.push(item)
  } else {
    selectedAssets.value.splice(index, 1)
  }
}

const placeholder = computed(() => {
  if (selectedAssets.value.length === 0) {
    return texts.value.fields[2].placeholder
  } else if (selectedAssets.value.length === 1) {
    return '1 feed selected'
  } else {
    return `${selectedAssets.value.length} feeds selected`
  }
})

watch(asset, () => {
  if (asset.value) {
    showAssetsList.value = true
  }
})

watch(showAssetsList, (value) => {
  emit('show-asset-list-changed', value)
})
</script>

<style lang="scss" scoped>
.asset-select {
  position: relative;
  z-index: 9;

  &.opened {
    :deep(.field) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

.options-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-radius: 0px 0px 10px 10px;
  border: 1px solid var(--field-stroke);
  border-top: 0;
  background: var(--field-bg, rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(50px);
}

.options {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 350px;

  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 3px;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(29, 34, 68, 0.2);
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #000d30;
  }
}

.request {
  color: var(--CTA, #3d6ef6);
  padding: 18px 20px;
}

.field-wrapper {
  position: relative;
}

.chevron {
  position: absolute;
  right: 20px;
  bottom: 21px;
  transform: rotate(180deg);
  transition: transform 0.3s;
  .opened & {
    transform: rotate(0);
  }

  :deep(path) {
    stroke: var(--Text, #000);
  }
}
</style>
